
import RexAutocomplete from './Autocomplete.vue'
import RexCheckbox from './Checkbox.vue'
import RexCheckboxesGroup from './CheckboxesGroup.vue'
import RexDate from './Date.vue'
import RexDistance from './Distance.vue'
import RexEditor from './Editor.vue'
import RexInput from './Input.vue'
import RexRadioGroup from './RadioGroup.vue'
import RexSelect from './Select.vue'
import RexTime from './Time.vue'
import RexDurations from './Durations.vue'
import RexTourists from './Tourists.vue'
import RexSlider from './Slider.vue'

export {
  RexAutocomplete,
  RexCheckbox,
  RexCheckboxesGroup,
  RexDate,
  RexDistance,
  RexEditor,
  RexInput,
  RexRadioGroup,
  RexSelect,
  RexTime,
  RexDurations,
  RexTourists,
  RexSlider
}